import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  Input,
  Button,
  Typography,
  Modal,
  Tag,
  Popconfirm,
  Divider,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
// import {
//   ChangeTestSearchText,
//   ChangeTestTableData,
//   ChangeTestDetailsModalState,
// } from "../../../actions/trainerAction";
import {
  changeTestSearchText,
  changeTestTableLoadingStatus,
  changeTestDetailsModalState,
} from "../../../reducers/trainer";
import Highlighter from "react-highlight-words";
import {
  DeleteOutlined,
  SearchOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import moment from "moment";
import Alert from "../../common/alert";
import { SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import TestDetails from "../testdetails/testdetails";
import "./alltest.css";
import { fetchAllTests } from "../../../features/trainerAsync";

const AllTests = () => {
  const searchInput = useRef(null);
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const { Title } = Typography;

  const {
    TestTableData,
    loading,
    TestsearchText,
    TestDetailsmodalOpened,
    DataActiveTestDetails,
  } = useSelector((state) => state.trainer);
  const { testDetailsId } = DataActiveTestDetails;
  //  console.log("Table",TestTableData);

  useEffect(() => {
    dispatch(fetchAllTests());
  }, [dispatch]);

  const openModal = (id, questions) => {
    dispatch(
      changeTestDetailsModalState({
        payload1: true,
        payload2: id,
        payload3: questions,
      })
    );
  };

  const closeModal = () => {
    dispatch(
      changeTestDetailsModalState({
        payload1: false,
        payload2: null,
        payload3: [],
      })
    );
  };

  const handleTableChange = (newPagination, filters, sorter) => {
    setPagination(newPagination);
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    dispatch(changeTestSearchText(selectedKeys[0]));
    setPagination((prev) => ({ ...prev, current: 1 })); // reset page to 1
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    dispatch(changeTestSearchText(""));
    setPagination((prev) => ({ ...prev, current: 1 })); // reset page to 1
  };

  const deleteTest = async (id) => {
    try {
      const response = await SecurePost({
        url: apis.DELETE_TEST,
        data: { _id: id },
      });
      if (response.data.success) {
        Alert("success", "Success", response.data.message);
        dispatch(changeTestTableLoadingStatus());
      } else {
        Alert("warning", "Warning!", response.data.message);
      }
    } catch (error) {
      const message = error.response
        ? error.response.data.message
        : error.message;
      Alert("error", "Error!", message);
    }
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      TestsearchText ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
            color: "black",
          }}
          searchWords={[TestsearchText]}
          autoEscape
          textToHighlight={text?.toString() || ""}
        />
      ) : (
        text
      ),
  });

  const getColumnSubjectSearchProps = (dataIndex) => ({
    ...getColumnSearchProps(dataIndex),
    onFilter: (value, record) => {
      const subjects = record[dataIndex];
      return subjects?.some((subject) =>
        subject.topic.toLowerCase().includes(value.toLowerCase())
      );
    },
  });

  const getColumnDateSearchProps = (dataIndex) => ({
    ...getColumnSearchProps(dataIndex),
    onFilter: (value, record) => {
      const date = moment(record[dataIndex]).format("DD/MM/YYYY");
      return date.toLowerCase().includes(value.toLowerCase());
    },
  });

  const nameColumnSearchProps = getColumnSearchProps("title");

  const columns = [
    {
      title: <span style={{ color: "black" }}>Name</span>,
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
      ...nameColumnSearchProps,
      render: (text, record) => {
        const defaultRendered = nameColumnSearchProps.render
          ? nameColumnSearchProps.render(text, record)
          : text;
        return <span style={{ color: "black" }}>{defaultRendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Subjects</span>,
      dataIndex: "subjects",
      key: "subjects",
      sorter: (a, b) => {
        const topicA = a.subjects?.[0]?.topic || "";
        const topicB = b.subjects?.[0]?.topic || "";
        return topicA.localeCompare(topicB);
      },
      ...getColumnSubjectSearchProps("subjects"),
      render: (subjects) =>
        subjects?.map((tag) => (
          <Tag key={tag._id} color="geekblue">
            {tag.topic.toUpperCase()}
          </Tag>
        )),
    },
    {
      title: <span style={{ color: "black" }}>Created on</span>,
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      ...getColumnDateSearchProps("createdAt"),
      render: (date) => (
        <span style={{ color: "black" }}>
          {moment(date).format("DD/MM/YYYY")}
        </span>
      ),
    },
    {
      title: <span style={{ color: "black" }}>Created By</span>,
      dataIndex: "createdBy",
      key: "createdBy",
      render: (user) =>
        user ? (
          <>
            <div style={{ color: "black" }}>{user.name || "N/A"}</div>
            <div style={{ color: "black" }}>{user.emailid || ""}</div>
          </>
        ) : (
          "N/A"
        ),
    },
    {
      title: <span style={{ color: "black" }}>Action</span>,
      key: "action",
      render: (_, record) => (
        <>
          <Button
            type="primary"
            icon={<InfoCircleOutlined />}
            shape="circle"
            onClick={() => openModal(record._id, record.questions)}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => deleteTest(record._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              shape="circle"
            />
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div className="admin-table-container">
      <div className="register-trainer-form-header">
        <Title
          level={4}
          style={{ color: "#fff", textAlign: "center", margin: 0 }}
        >
          List of Tests
        </Title>
      </div>
      <Table
        bordered
        rowKey="_id"
        columns={columns}
        dataSource={TestTableData}
        loading={loading}
        size="medium"
        pagination={{
          ...pagination,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
        onChange={handleTableChange}
        style={{ backgroundColor: "#fff", padding: "10px" }}
      />

      <Modal
        open={TestDetailsmodalOpened}
        title="Test Details"
        onCancel={closeModal}
        afterClose={closeModal}
        width="80%"
        style={{ top: 20 }}
        destroyOnHidden={true}
        footer={null}
        styles={{ maxHeight: "80vh", overflow: "auto" }}
      >
        <TestDetails id={testDetailsId} />
      </Modal>
    </div>
  );
};

export default AllTests;
